import React, { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react'

import style from './Button.module.css'

type DefaultButtonPropsType = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

type PropsType = DefaultButtonPropsType & {
  children: ReactNode
  className?: string
  accent?: boolean
  link?: boolean
}

export const Button = ({ children, className = '', accent = false, ...restProps }: PropsType) => {
  return (
    <button className={`${style.button} ${accent ? style.accent : ''} ${className}`} {...restProps}>
      {children}
    </button>
  )
}
